var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB2B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linear/code"
  }, /*#__PURE__*/React.createElement("g", {
    id: "code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33327 13C8.67327 13.33 8.12327 13.82 7.71327 14.43C7.48327 14.78 7.48327 15.22 7.71327 15.57C8.12327 16.18 8.67327 16.67 9.33327 17",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5432 13C16.2032 13.33 16.7532 13.82 17.1632 14.43C17.3932 14.78 17.3932 15.22 17.1632 15.57C16.7532 16.18 16.2032 16.67 15.5432 17",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.33325 22H15.3333C20.3333 22 22.3333 20 22.3333 15V9C22.3333 4 20.3333 2 15.3333 2H9.33325C4.33325 2 2.33325 4 2.33325 9V15C2.33325 20 4.33325 22 9.33325 22Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.56323 8.01L21.7832 8",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2B);
export default __webpack_public_path__ + "static/media/b2b.f183d4c77205e2e51dbcd3da985413bd.svg";
export { ForwardRef as ReactComponent };